import React from 'react';
import { convertIcon } from '../component/Icon';

interface OverrideIconSize20 {
  size?: '20';
}

function SvgComponent({
  color = '#616161',
  size = '20',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize20) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 9.5V6.5C10.5 6.22386 10.2761 6 10 6C9.72386 6 9.5 6.22386 9.5 6.5V9.5H6.5C6.22386 9.5 6 9.72386 6 10C6 10.2761 6.22386 10.5 6.5 10.5H9.5V13.5C9.5 13.7761 9.72386 14 10 14C10.2761 14 10.5 13.7761 10.5 13.5V10.5H13.5C13.7761 10.5 14 10.2761 14 10C14 9.72386 13.7761 9.5 13.5 9.5H10.5Z"
        fill={color}
      />
      <circle cx="10" cy="10" r="7" stroke={color} />
    </svg>
  );
}

const IconComponent = convertIcon(SvgComponent, 'circle-plus');
export default IconComponent;
